﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { IBoxNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { PrimitiveMeshNode } from './primitive-mesh-node';

@Kb3dModel({
    token: Token.BoxNode,
})
export class BoxNode extends PrimitiveMeshNode implements IBoxNode {
    public constructor() {
        super();
    }
    public height: number;
    public width: number;
    public depth: number;
    public tessellation: number;
}

export function isBoxMesh(node: Kb3dObject): node is BoxNode {
    return instanceOf(node, Token.BoxNode);
}
